module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.cue && _vm.cue.data) ? _c('div', {
    staticClass: "ql-cue-header-shell",
    class: {
      'ql-cue-header-shell--noteslist': _vm.notesListLinked
    }
  }, [_c('md-toolbar', {
    ref: "ql-cue-header",
    staticClass: "md-dense ql-cue-header",
    class: {
      'ql-cue-worknote-marked': _vm.cue.data && _vm.isActiveCue
    }
  }, [_c('div', {
    staticClass: "ql-cue-layer-func"
  }, [_c('div', {
    staticClass: "ql-cue-layer-func-back",
    class: _vm.cuePlacementclass(_vm.cue),
    style: ({
      backgroundColor: _vm.layer.color
    }),
    on: {
      "click": _vm.toggle,
      "contextmenu": function($event) {
        return _vm.preventContextFunc($event)
      }
    }
  }), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v(_vm._s(_vm.headerClickTooltip))])], 1), _vm._v(" "), _c('div', {
    staticClass: "cue-header-title",
    class: {
      'cue-header-both': [_vm.headerBox.title, _vm.headerBox.label, _vm.headerBox.time].filter(Boolean).length >= 2
    },
    style: (_vm.cueHeaderTitleStyles),
    attrs: {
      "id": 'cue-header-title-' + _vm.cue.id
    },
    on: {
      "dblclick": _vm.selectWordInField
    }
  }, [_c('layer-picker', {
    attrs: {
      "currentLayer": _vm.layer,
      "layers": _vm.layers,
      "editable": _vm.editable,
      "locked": _vm.locked,
      "cue": _vm.cue,
      "titleFontSize": _vm.titleFontSize,
      "layerCueLineOpacity": _vm.cueLineOpacity,
      "layerCueBoxOpacity": _vm.cueBoxOpacity,
      "headerBox": _vm.headerBox,
      "svgTrueHeight": _vm.svgTrueHeight
    },
    on: {
      "selectLayer": _vm.selectLayer,
      "toggle": _vm.toggle,
      "focusWorkNote": _vm.focusInputWorkNote
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cue-header-separator",
    class: {
      'cue-header-separator--empty': _vm.headerBox.layerName === false
    }
  }), _vm._v(" "), (_vm.headerBox.title) ? [(!_vm.isEditing) ? _c('div', {
    staticClass: "cue-header-cue-title",
    class: {
      'placeholder': !_vm.cue.title,
      'short-box': _vm.cue.title.length <= 12
    },
    style: (_vm.titleStyle),
    attrs: {
      "id": 'cue-header-number-' + _vm.cue.id
    },
    on: {
      "click": _vm.edit,
      "touchstart": _vm.edit
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.cue.title || 'Cue Number') + "\n                    "), (_vm.editable && !_vm.isEditing && !_vm.isEditingDescription) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Click to edit")]) : _vm._e()], 1) : _c('form', {
    class: _vm.showMarginView ? 'margin-view' : '',
    style: (_vm.titleStyle),
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submit.apply(null, arguments)
      },
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.keyPress.apply(null, arguments)
      },
      "keydown": _vm.keyDown
    }
  }, [_c('md-input-container', {
    staticClass: "cue-header-title-edit"
  }, [_c('md-input', {
    ref: "input_cue_title",
    attrs: {
      "value": _vm.cue.title,
      "placeholder": "Cue Number"
    },
    on: {
      "blur": function ($value) { return _vm.modifyCue('title', $value, true); }
    }
  }), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Enter to save, Escape to cancel")])], 1)], 1)] : _vm._e(), _vm._v(" "), (_vm.headerBox.title && _vm.headerBox.label) ? _c('div', {
    staticClass: "cue-header-separator"
  }) : _vm._e(), _vm._v(" "), (_vm.headerBox.label) ? [(!_vm.isEditingDescription) ? _c('div', {
    staticClass: "cue-header-cue-description",
    class: {
      'placeholder': !_vm.cueLabel,
      'short-box': _vm.cueLabel.length <= 12
    },
    style: (_vm.titleStyle),
    attrs: {
      "id": 'cue-header-label-' + _vm.cue.id
    },
    on: {
      "click": _vm.editDescription
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.cueLabel || 'Cue Label') + "\n                    "), (_vm.editable && !_vm.isEditing && !_vm.isEditingDescription) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Click to edit")]) : _vm._e()], 1) : _c('form', {
    class: _vm.showMarginView ? 'margin-view' : '',
    style: (_vm.titleStyle),
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submitDescription.apply(null, arguments)
      },
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.keyPressDescription.apply(null, arguments)
      },
      "keydown": _vm.keyDownDescription
    }
  }, [_c('md-input-container', {
    staticClass: "cue-header-description-edit"
  }, [_c('md-input', {
    ref: "input_cue_description",
    attrs: {
      "value": _vm.cue.data.label,
      "placeholder": "Cue Label"
    },
    on: {
      "blur": function ($value) { return _vm.modifyCue('data.label', $value, true); }
    }
  }), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Enter to save, Escape to cancel")])], 1)], 1)] : _vm._e(), _vm._v(" "), ((_vm.headerBox.title || _vm.headerBox.label) && _vm.headerBox.time) ? _c('div', {
    staticClass: "cue-header-separator"
  }) : _vm._e(), _vm._v(" "), (_vm.headerBox.time) ? [(!_vm.isEditingTime) ? _c('div', {
    staticClass: "cue-header-cue-time",
    class: {
      'placeholder': !_vm.cue.data.time,
      'short-box': (_vm.cue.data.time || '').length <= 12
    },
    style: (_vm.titleStyle),
    attrs: {
      "id": 'cue-header-time-' + _vm.cue.id
    },
    on: {
      "click": _vm.editTime,
      "touchstart": _vm.editTime
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.cue.data.time || 'Cue Time') + "\n                    "), (_vm.editable && !_vm.isEditing && !_vm.isEditingDescription && !_vm.isEditingTime) ? _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Click to edit")]) : _vm._e()], 1) : _c('form', {
    class: _vm.showMarginView ? 'margin-view' : '',
    style: (_vm.titleStyle),
    attrs: {
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.submitTime.apply(null, arguments)
      },
      "keyup": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.keyPressTime.apply(null, arguments)
      },
      "keydown": _vm.keyDownTime
    }
  }, [_c('md-input-container', {
    staticClass: "cue-header-time-edit"
  }, [_c('md-input', {
    ref: "input_cue_time",
    attrs: {
      "value": _vm.cue.data.time,
      "placeholder": "Cue Time"
    },
    on: {
      "blur": function ($value) { return _vm.modifyCue('data.time', $value, true); }
    }
  }), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Enter to save, Escape to cancel")])], 1)], 1)] : _vm._e(), _vm._v(" "), _c('svg', {
    staticClass: "ql-cue-worknote-marker",
    class: {
      'ql-cue-worknote-marker--noteslist': _vm.worknoteFromNotesList
    },
    style: (_vm.worknoteStyles),
    attrs: {
      "viewBox": "0 0 256 256",
      "aria-hidden": "true",
      "focusable": "false"
    }
  }, [_c('path', {
    attrs: {
      "fill": "currentColor",
      "d": "M218.29,182.17a12,12,0,0,1-16.47,4.12L140,149.19V216a12,12,0,0,1-24,0V149.19l-61.82,37.1a12,12,0,1,1-12.35-20.58L104.68,128,41.83,90.29A12,12,0,1,1,54.18,69.71L116,106.81V40a12,12,0,0,1,24,0v66.81l61.82-37.1a12,12,0,1,1,12.35,20.58L151.32,128l62.85,37.71A12,12,0,0,1,218.29,182.17Z"
    }
  })])], 2), _vm._v(" "), (_vm.isFloatingCue || _vm.editable) ? _c('div', {
    staticClass: "cue-header-side-actions"
  }, [(_vm.isFloatingCue) ? [_c('div', {
    staticClass: "button-container",
    style: (_vm.tetherWrapperStyle),
    on: {
      "contextmenu": function($event) {
        return _vm.preventContext($event)
      },
      "touchstart": _vm.checkTwoFingerTap
    }
  }, [_c('span', {
    staticClass: "move-button drag fill-button-retether"
  }, [_c('div', {
    staticClass: "fill-button",
    style: (_vm.tetherStyle)
  }), _vm._v(" "), _c('md-tooltip', [_vm._v("Click and drag to move cue. Right click to re-tether.")])], 1)])] : [(_vm.editable) ? _c('div', {
    staticClass: "button-container",
    style: (_vm.tetherWrapperStyle),
    on: {
      "click": _vm.untetherCue
    }
  }, [_c('span', {
    staticClass: "move-button drag"
  }, [_c('div', {
    staticClass: "fill-button",
    style: (_vm.tetherStyle)
  }), _vm._v(" "), _c('md-tooltip', [_vm._v("Click to untether cue")])], 1)]) : _vm._e()]], 2) : _vm._e()]), _vm._v(" "), (_vm.notesListLinked) ? _c('button', {
    staticClass: "noteslist-add-note-outside",
    style: (_vm.noteslistAddNoteStyles),
    attrs: {
      "type": "button",
      "aria-label": "Add Note in The Notes List"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.openAddNote.apply(null, arguments)
      },
      "mousedown": function($event) {
        $event.stopPropagation();
      },
      "touchstart": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('img', {
    staticClass: "noteslist-add-note-icon",
    attrs: {
      "src": _vm.noteslistNoteIconSrc,
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "noteslist-add-note-icon noteslist-add-note-icon--hover",
    attrs: {
      "src": _vm.noteslistNoteIconHoverSrc,
      "alt": ""
    }
  }), _vm._v(" "), _c('md-tooltip', {
    attrs: {
      "md-direction": "top"
    }
  }, [_vm._v("Add Note in The Notes List")])], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-347d411a","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/project/cues/cue-header.vue
// module id = 1223
// module chunks = 21